/**
 * Shared P&L / App input mutation paths.
 * Stage Finance Financial Drivers and OutputPanel must use these so both
 * surfaces edit the same inputs/assumptions (one source of truth).
 */

/** Apply a % (rate) or CHF (amount) override — same shape as OutputPanel. */
export function applyFieldOverride(prev, fieldKey, override) {
  const base = prev && typeof prev === 'object' ? prev : {};
  return {
    ...base,
    overrides: { ...(base.overrides || {}), [fieldKey]: override },
  };
}

/** Clear overrides for the given field keys. */
export function clearFieldOverrides(prev, keys = []) {
  const base = prev && typeof prev === 'object' ? prev : {};
  const next = { ...(base.overrides || {}) };
  keys.forEach((k) => { delete next[k]; });
  return { ...base, overrides: next };
}

/** Update a capitalSources base selector (equity / bankDebt / privateCapital / fees). */
export function applyCapitalSource(prev, field, source) {
  const base = prev && typeof prev === 'object' ? prev : {};
  return {
    ...base,
    capitalSources: { ...(base.capitalSources || {}), [field]: source },
  };
}

/**
 * Update nested bankDebt assumption fields (interest, duration, fees, construction facility).
 * Same path as AssumptionsModal → setAssumptions.
 */
export function applyBankDebtAssumption(prev, key, value) {
  const base = prev && typeof prev === 'object' ? prev : {};
  return {
    ...base,
    bankDebt: {
      ...(base.bankDebt || {}),
      [key]: value,
    },
  };
}

/** Cost override keys edited from Stage Finance Financial Drivers. */
export const FINANCIAL_DRIVER_COST_KEYS = [
  'notaryFees',
  'otherLandFees',
  'constructionCost',
  'constructionReserve',
  'architectureCost',
  'consultantsCost',
  'contingencyCost',
  'commercializationCost',
  'pilotageCost',
  'taxAmount',
];

/** Funding override keys edited from Stage Finance Financial Drivers. */
export const FINANCIAL_DRIVER_FUNDING_KEYS = [
  'equityRequired',
  'bankDebt',
  'privateCapital',
  'upfrontFees',
];
